export const AttachmentEntityType = {
  invoiceRequest: 'invoice_request',
  expenseRequest: 'expense_request',
  supportTicket: 'support_ticket',
};

export const PaidBy = {
  yeuls: 'yeuls',
  agent: 'agent',
};

export const VatOption = {
  standard18: 'standard_18',
  zero: 'zero',
  exempt: 'exempt',
};

export const VAT_RATE_BY_OPTION = {
  [VatOption.standard18]: 18,
  [VatOption.zero]: 0,
  [VatOption.exempt]: 0,
};

export const currencyOptions = [
  { value: 'ILS', tLabel: 'currency-ils' },
  { value: 'USD', tLabel: 'currency-usd' },
  { value: 'EUR', tLabel: 'currency-eur' },
  { value: 'GBP', tLabel: 'currency-gbp' },
];

export const recurringOptions = [
  { value: 'yes', tLabel: 'recurring-invoice-yes' },
  { value: 'no', tLabel: 'recurring-invoice-no' },
];

export const recurringDayOptions = Array.from({ length: 28 }, (_, index) => ({
  value: `${index + 1}`,
  tLabel: `${index + 1}`,
}));

export const paymentTermsOptions = [
  { value: 'immediate', tLabel: 'payment-terms-immediate' },
  { value: 'current_month', tLabel: 'payment-terms-current-month' },
  { value: 'net_30', tLabel: 'payment-terms-net-30' },
  { value: 'net_60', tLabel: 'payment-terms-net-60' },
  { value: 'net_90', tLabel: 'payment-terms-net-90' },
];

export const vatInclusionOptions = [
  { value: 'excluding_vat', tLabel: 'vat-inclusion-excluding' },
  { value: 'including_vat', tLabel: 'vat-inclusion-including' },
];

export const vatOptions = [
  { value: VatOption.standard18, tLabel: 'vat-18' },
  { value: VatOption.zero, tLabel: 'vat-0' },
  { value: VatOption.exempt, tLabel: 'vat-exempt' },
];

export const expenseCategoryOptions = [
  { value: 'office_supplies', tLabel: 'expense-category-office-supplies' },
  { value: 'travel_fuel', tLabel: 'expense-category-travel-fuel' },
  { value: 'food_hospitality', tLabel: 'expense-category-food-hospitality' },
  {
    value: 'software_subscriptions',
    tLabel: 'expense-category-software-subscriptions',
  },
  {
    value: 'computer_electronics',
    tLabel: 'expense-category-computer-electronics',
  },
  {
    value: 'advertising_marketing',
    tLabel: 'expense-category-advertising-marketing',
  },
  {
    value: 'professional_services',
    tLabel: 'expense-category-professional-services',
  },
  { value: 'training_education', tLabel: 'expense-category-training-education' },
  { value: 'communications', tLabel: 'expense-category-communications' },
  {
    value: 'office_rent_maintenance',
    tLabel: 'expense-category-office-rent-maintenance',
  },
  { value: 'other', tLabel: 'expense-category-other' },
];

export const departmentOptions = [
  { value: 'it_computing', tLabel: 'department-it-computing' },
  {
    value: 'maintenance_operations',
    tLabel: 'department-maintenance-operations',
  },
  { value: 'hr_payroll', tLabel: 'department-hr-payroll' },
  { value: 'finance_accounting', tLabel: 'department-finance-accounting' },
  { value: 'other', tLabel: 'department-other' },
];

export const VAT_RATE = 18;
